export default __webpack_public_path__ + "static/media/Extend.137dc4d7.png";